import React, { Fragment, useState, useEffect, useRef } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useTranslation } from 'react-i18next';
import travelimg from './planeblack.png';
import Cookies from 'js-cookie';

function EvisaProducts() {

  const { t } = useTranslation();

  const cardContainerRef = useRef(null)

  // const [insuretoken, setInsuretoken] = useState(null);
  // useEffect(() => {
  //     fetch('https://api.superjetom.com/create_inbound_token')
  //       .then(response => response.json())
  //       .then(data => {
  //         // debugger;
  //         setInsuretoken(data.result.data.token);
  //       })
  //       .catch(error => {
  //         console.error('Error fetching countries:', error);
  //       });
  //   }, []);

  const [userData, setUserData] = useState();

  useEffect(() => {
    const storedUserString = Cookies.get('userData'); //sessionStorage.getItem('userData')
    if (storedUserString != undefined) {
      const storedUser = JSON.parse(storedUserString);
      setUserData(storedUser);
    } else {
      // alert("token expired");
      // window.location.href = '/';
    }
  }, []);


  useEffect(() => {
    const container = cardContainerRef.current;
    let scrollInterval;

    if (container) {
      // Start an interval to scroll the container
      scrollInterval = setInterval(() => {
        if (container.scrollLeft + container.clientWidth >= container.scrollWidth) {
          
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 1; 
        }
      }, 20); 

      return () => clearInterval(scrollInterval);
    }
  }, []);

  const resetData = () =>{
    const inboundDhofarData = Cookies.set('dhofarData', null);
    const outboundDhofarData = Cookies.set('dhofarDataoutbound', null); 
    const personalDhofarData = Cookies.set('personalData', null); 
    const healthDhofarData = Cookies.set('HealthIndividualData', null);
    const medicalDhofarData = Cookies.set('medicalData', null); 
    const medicalAffordableData = Cookies.set('medicalAffordableData', null); 
    const homeDhofarData = Cookies.set('homeData', null);
    sessionStorage.clear();
      
  }
  const handleClick = () => {
    resetData();
    window.location.href = '/Visa';
  };

  const handleClick2 = () => {
    resetData();
    window.location.href = '/oman-visa-form';
  };



  const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';


  return (




    <div className="App">
      <div className="header_section1">
        <Navbar />
        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">{t('VISA')}</h3>
          </div>
        </div>
      </div>

      <div className="features_section layout_padding">
        <div className="container">
          <h1 className="features_text">
            {(lnstr === 'en') ? <div>{t('Our')} <span className="htext">{t('Products')}</span></div> : 'منتجاتنا'}
          </h1>
          <p className="text-center undertxt">{t('Offered by us to cover all your needs')}.</p>

          <div className="features_section2">

          {/* <div className="row">
          <div className="col-md-4 col-lg-4 col-sm-12 mb-4"></div>
                       <div className="col-md-4 col-lg-4 col-sm-12 mb-4  justify-content-center" style={{  cursor: 'pointer'}}  onClick={handleClick}>
                <div className="service-item rounded">
                  <div className="service-img rounded-top"></div>
                  <div className="service-content rounded-bottom card bg-light p-4">
                    <div className="service-content-inner">
                      <p className="text-center policytxt">{t('Buy Policy')} <span className="fa fa-arrow-right"></span></p>
                      <h5 className="mt-3 text-center">{t('Travel Insurance')}</h5>
                    </div>
                  </div>
                  </div>
                
              </div>
              <div className="col-md-4 col-lg-4 col-sm-12 mb-4"></div>
              </div> */}

   
          <div className="row d-flex justify-content-center">

                       <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4  justify-content-center" style={{  cursor: 'pointer'}}  onClick={handleClick}>
                <div className="service-item rounded">
                  <div className="service-img rounded-top"></div>
                  <div className="service-content rounded-bottom card bg-light p-4">
                    <div className="service-content-inner">
                      <p className="text-center policytxt">{t('Apply E-Visa')}&nbsp; <span className="fa fa-arrow-right"></span></p>
                      <h5 className="mt-3 text-center">{t('E-Visa')}</h5>
                    </div>
                  </div>
                  </div>
                
              </div>



              
            
              {/* <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4  justify-content-center" style={{  cursor: 'pointer'  }}  onClick={handleClick2}>
              
                 <div className="service-item rounded">
                  <div className="service-img rounded-top"></div>
                  <div className="service-content rounded-bottom card bg-light p-4" style={{borderRadius : '0px 0px 10px 0px'}}>
                    <div className="service-content-inner">
                      <p className="text-center policytxt">{t('Apply E-Visa')}&nbsp;<span className="fa fa-arrow-right"></span></p>
                      <h5 className="mt-3 text-center">{(lnstr === 'en') ? 'Oman Visa':'تأشيرة عُمان'}</h5>
                    </div>
                  </div>
                  </div>
                </div> */}
              
                

                  </div>
                
             
            </div>
            </div>
            </div>
            
          
        
      
     
      <Footer />
    </div>
  );
}

export default EvisaProducts;

